import { AlertaApi } from './api.schema';
import { AlertaUi } from './ui.schema';

export const transformAlertaApiToUi = (alertaApi: AlertaApi): AlertaUi => {
  return {
    id: alertaApi.id.toString(),
    encabezado: alertaApi.encabezado,
    descripcion: alertaApi.descripcion,
    fecha_creacion_alerta: alertaApi.fecha_creacion_alerta,
    estado_alerta: alertaApi.estado_alerta,
    isRead: alertaApi.estado_alerta !== 'No Visualizada'
  };
};

export const transformAlertasApiToUi = (alertasApi: AlertaApi[]): AlertaUi[] => {
  return alertasApi.map(transformAlertaApiToUi);
};

export * from './api.schema';
export * from './ui.schema'; 